import React from 'react';
import { useLoaderData } from 'react-router-dom';
import './Committee.css';

const Committee = () => {
    // Get data from the router loader
    const loadedData = useLoaderData();
    const committeeInfo = loadedData?.data || [];

    // Add safety check for undefined committeeInfo
    if (!committeeInfo || !Array.isArray(committeeInfo) || committeeInfo.length === 0) {
        return (
            <section className="committee-container">
                <div className="heading-container">
                    <h4>Committee Members</h4>
                </div>
                <div className="all-committees-card">
                    <p style={{ textAlign: 'center', color: '#475569', fontSize: '1.1rem' }}>
                        {committeeInfo.length === 0 ? 'No committee information available.' : 'Loading committee information...'}
                    </p>
                </div>
            </section>
        );
    }

    return (
        <section className="committee-container">
            <div className="heading-container">
                <h4>Committee Members</h4>
            </div>
            
            {/* Single Card for All Committees */}
            <div className="all-committees-card">
                {committeeInfo.map((item, index) => (
                    <div key={index} className="committee-item">
                        {/* Display Main Committee if it exists */}
                        {item?.mainCommittee && (
                            <div className="committee-block">
                                <h3 className="committee-name">{item?.mainCommittee?.committeeName}</h3>
                                <div className="members-compact-list">
                                    {item.mainCommittee?.members?.map((member, memberIndex) => (
                                        <span key={memberIndex} className="member-compact">
                                            <strong>{member?.name}</strong>
                                            {member?.affiliation && <span>, {member?.affiliation}</span>}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* Display Sub Committee only if Main Committee doesn't exist */}
                        {!item?.mainCommittee && item?.subCommittee && (
                            <div className="committee-block">
                                <h3 className="committee-name">{item?.subCommittee?.subCommitteeName}</h3>
                                <p className="committee-label">Committee Members:</p>
                                <div className="members-compact-list">
                                    {item.subCommittee?.subCommitteeMembers?.map((member, memberIndex) => (
                                        <span key={memberIndex} className="member-compact">
                                            <strong>{member?.name}</strong>
                                            {member?.affiliation && <span>, {member?.affiliation}</span>}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Committee;